module.exports = __webpack_public_path__ + "media/images/story_ranking_mailer/title-a26cd79f4af9c8da858f2fe764d5a06e.png";